import { render, staticRenderFns } from "./bunkersSupplyTable.vue?vue&type=template&id=6dc15ec6"
import script from "./bunkersSupplyTable.vue?vue&type=script&lang=js"
export * from "./bunkersSupplyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports